import {
  AvailableSpecificFilters,
  DateRangeError,
  DateRangeErrorType,
  getRangeTooWideHint,
  MAX_DATE_RANGE_DAYS,
} from '@/utils/dashboardDateRange';

interface DateRangeErrorMessageProps {
  error: DateRangeError;
  // Solo se sugieren los buscadores que el usuario ve en el dashboard
  availableFilters: AvailableSpecificFilters;
}

export default function DateRangeErrorMessage({
  error,
  availableFilters,
}: DateRangeErrorMessageProps) {
  if (error.type !== DateRangeErrorType.RangeTooWide) {
    return <span>{error.message}</span>;
  }
  return (
    <>
      El intervalo no puede superar
      {' '}
      <strong>{MAX_DATE_RANGE_DAYS}</strong>
      {' '}
      días.
      <br />
      {getRangeTooWideHint(availableFilters)}
    </>
  );
}
